import React, {useEffect, useRef, useState} from 'react';
import styles from './SubtitlesControl.module.css';
import {cc_captions, check} from '../../../assets/images';
import {tapyblPlayerText} from '../tapyblPlayerText';
import featureFlags, {FeatureFlagName} from '../../../utils/featureFlags';

type UiMode = 'small' | 'big';
interface SubtitlesControlProps {
  subtitlesAvailable: boolean;
  subtitlesEnabled: boolean;
  setSubtitlesEnabled: (enabled: boolean) => void;
  uiMode: UiMode;
}

const SubtitlesControlComponent: React.FC<SubtitlesControlProps> = ({
  subtitlesAvailable,
  subtitlesEnabled,
  setSubtitlesEnabled,
  uiMode,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const subtitlesFeatureEnabled = featureFlags.get(FeatureFlagName.Subtitles);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setMenuVisible(false);
      }
    };

    if (menuVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Clean up
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuVisible]);

  const toggleMenu = () => {
    setMenuVisible(prev => !prev);
  };
  const selectCc = (enabled: boolean) => {
    setSubtitlesEnabled(enabled);
    setMenuVisible(false);
  };

  if (!subtitlesAvailable || !subtitlesFeatureEnabled) return null;

  return (
    <div ref={containerRef} className={styles.CcWrapper}>
      <div
        className={`${styles.CcMenu} ${
          menuVisible ? styles.visible : styles.hidden
        }`}>
        <div className={styles.CcMenuTitle}>{tapyblPlayerText.captions}</div>
        <div className={styles.CcMenuItem} onClick={() => selectCc(true)}>
          {tapyblPlayerText.on}
          {subtitlesEnabled ? (
            <img src={check} alt="CC on" className={styles.CheckIcon} />
          ) : null}
        </div>
        <div className={styles.CcMenuItem} onClick={() => selectCc(false)}>
          {tapyblPlayerText.off}
          {!subtitlesEnabled ? (
            <img src={check} alt="CC off" className={styles.CheckIcon} />
          ) : null}
        </div>
      </div>
      <button
        type="button"
        className={
          uiMode === 'small' ? styles.SmallCcButton : styles.BigCcButton
        }
        onClick={toggleMenu}
        aria-pressed={subtitlesEnabled}>
        <img src={cc_captions} alt="CC Icon" />
        <span>{tapyblPlayerText.captions}</span>
      </button>
    </div>
  );
};

const SubtitlesControl = React.memo(SubtitlesControlComponent);

export default SubtitlesControl;
